<template>
  <div>
    <div class="orderMain">
      <el-tabs type="border-card">
        <el-tab-pane label="订单类型">
          <div class="mb15">
            <span class="fz16">订单类型：</span>
            <el-select clearable  v-model="orderTyped" @change="orderType">
              <el-option
                v-for="item in orderSelectData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <el-form :inline="true" :model="formInline">
            <el-form-item label="订单编号：">
              <el-input
                v-model="formInline.orderNumer"
                placeholder="请输入订单编号"
              ></el-input>
            </el-form-item>
            <el-form-item label="会员姓名或电话：">
              <el-input
                v-model="formInline.memberIphone"
                placeholder="请输入会员姓名或电话"
              ></el-input>
            </el-form-item>
            <el-form-item label="创建人：">
              <el-input
                v-model="formInline.creator"
                placeholder="创建人"
              ></el-input>
            </el-form-item>
            <el-form-item label="订单日期：">
              <el-date-picker
                v-model="formInline.orderDate"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
              <el-button type="primary" class="ml20"> 查询 </el-button>
            </el-form-item>
          </el-form>
          <div class="flex">
            <div class="orderTotle">订单总数：3</div>
            <el-button
              type="primary"
              @click="createOrder"
              size="small"
              class="btnClass"
            >
              创建订单
            </el-button>
          </div>

          <el-table
            :data="orderData"
            border
            :row-class-name="tableRowClassName"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column prop="orderNumer" label="订单编号" align="center">
            </el-table-column>
            <el-table-column prop="member" label="会员" align="center">
              <template slot-scope="scope">
                <div class="colorBlue">
                  {{ scope.row.member }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="memberIphone"
              label="会员电话"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="creator" label="创建人" align="center">
              <template slot-scope="scope">
                <div class="colorBlue">
                  {{ scope.row.creator }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="cost" label="费用名" align="center">
              <template slot-scope="scope">
                <div
                  v-for="item in scope.row.cost"
                  :key="item.id"
                  class="underline"
                >
                  {{ item.title }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="money" label="金额" align="center">
              <template slot-scope="scope">
                <div
                  v-for="item in scope.row.money"
                  :key="item.id"
                  class="underline colorRed"
                >
                  {{ item.money }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="subtotal" label="小计" align="center">
              <template slot-scope="scope">
                <div class="colorRed">
                  {{ scope.row.subtotal }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="reality" label="实收" align="center">
            </el-table-column>
            <el-table-column prop="orderType" label="订单类型" align="center">
            </el-table-column>
            <el-table-column prop="remark" label="备注" align="center">
            </el-table-column>
            <el-table-column fixed="right" label="操作" align="center">
              <template slot-scope="scope">
                <div v-show="scope.row.orderTypenum != '1'">
                  <el-button @click="openOrderDetail" type="text" size="small">
                    订单详情
                  </el-button>
                </div>
                <div v-show="scope.row.orderTypenum != '3'">
                  <el-button type="text" size="small"> 成绩录入 </el-button>
                </div>
                <div v-show="scope.row.orderTypenum != '3'">
                  <el-button type="text" size="small"> 比赛录入 </el-button>
                </div>
                <div v-show="scope.row.orderTypenum == '1'">
                  <el-button type="text" size="small" @click="overOrder">
                    订单结算
                  </el-button>
                </div>
                <div v-show="scope.row.orderTypenum == '1'">
                  <el-button type="text" size="small"> 取消订单 </el-button>
                </div>
                <div></div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="储物寄存">
          <el-form :inline="true" :model="storageForm">
            <el-form-item label="会员姓名或电话：">
              <el-input
                v-model="storageForm.memberIphone"
                placeholder="请输入会员姓名或电话"
              ></el-input>
            </el-form-item>
            <el-form-item label="近期到期：">
              <el-input
                v-model="storageForm.expire"
                placeholder="近期到期"
              ></el-input>
            </el-form-item>
            <el-button type="primary"> 查询 </el-button>
          </el-form>
          <div class="flex">
            <div></div>
            <el-button type="primary" @click="createStorage" class="btnClass">
              创建
            </el-button>
          </div>
          <el-table :data="storageData" border>
            <el-table-column
              type="index"
              width="50"
              align="center"
            ></el-table-column>
            <el-table-column prop="memberName" label="会员姓名" align="center">
              <template slot-scope="scope">
                <div class="colorBlue">
                  {{ scope.row.memberName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="memberIphone"
              label="手机号码"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="shop" label="门店" align="center">
            </el-table-column>
            <el-table-column prop="belonger" label="归属人" align="center">
            </el-table-column>
            <el-table-column prop="checkDate" label="寄存日期" align="center">
            </el-table-column>
            <el-table-column prop="expireDate" label="到期日期" align="center">
            </el-table-column>
            <el-table-column
              prop="remainingDay"
              label="剩余天数"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="pledge" label="押金" align="center">
              <template slot-scope="scope">
                <div class="colorBlue">
                  {{ scope.row.pledge }}
                </div>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small"> 续约 </el-button>
                <el-button type="text" size="small"> 退押金 </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>

      <el-dialog :visible.sync="createOrderDialog" width="40%" :close-on-click-modal="false">
        <div class="flexTitle">
          <span>创建订单</span>
          <span>创建时间：{{ createdate }}</span>
        </div>
        <div class="positionR">
          <el-form class="width70" label-width="100px">
            <el-form-item label="会员名称：">
              <el-input v-model="orderName" class="width70"></el-input>
            </el-form-item>
            <el-form-item label="会员电话：">
              <el-input v-model="orderIphone" class="width70"></el-input>
              <el-button type="text" class="ml10">查找</el-button>
            </el-form-item>
            <el-form-item label="创建人：">
              <el-select clearable  v-model="createMan" placeholder="请选择创建人">
                <el-option label="张三" value="zhangsan"></el-option>
                <el-option label="李四" value="lisi"></el-option>
              </el-select>
            </el-form-item>
          </el-form>

          <div class="oederManPhoto">
            <img
              src="https://www.runoob.com/wp-content/uploads/2017/01/vue.png"
              alt=""
            />
          </div>
        </div>
        <span slot="footer">
          <el-button type="primary" @click="creatVip">新建会员</el-button>
          <el-button type="primary">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog :visible.sync="openOrderDialog" width="40%" :close-on-click-modal="false">
        <div class="flexTitle">
          <span>订单结算</span>
          <span>创建时间：{{ createdate }}</span>
        </div>
        <div class="flex borderB">
          <div class="left">
            <div class="mb15">订单编号：8888</div>
            <div class="mb15">
              <span> 会员名称：aaaa </span>
              <span class="ml20"> 会员电话：1777777777777</span>
            </div>
            <div class="mb15">
              <span>会员等级：银卡会员</span>
              <el-button type="text" class="ml10" @click="creatVip">
                升卡储值</el-button
              >
            </div>
            <div class="mb15">会员积分：6000</div>
          </div>
          <div class="right">
            <img
              src="https://www.runoob.com/wp-content/uploads/2017/01/vue.png"
              alt=""
            />
          </div>
        </div>
        <div class="borderB">
          <div class="mb15">
            <h6 class="mb15">基本费用</h6>
            <div class="mb15">
              射箭组数：<el-input-number
                v-model="archeryNum"
                size="mini"
              ></el-input-number>
            </div>
            <div class="mb15">
              随行组数：<el-input-number
                v-model="togetherNum"
                size="mini"
              ></el-input-number>
            </div>
          </div>
        </div>
        <div class="borderB">
          <div class="mb15 positionR">
            <h6 class="mb15">其他费用</h6>
            <el-form :model="otherMoney" label-width="100px" class="width70">
              <el-form-item label="升卡" v-show="echo">
                <el-input type="text" v-model="upmoney" disabled></el-input
                ><span class="ml20">{{ upafter }}</span>
              </el-form-item>
              <el-form-item label="储值" v-show="echo">
                <el-input type="text" v-model="storedValue" disabled></el-input>
              </el-form-item>

              <div
                v-for="item in otherMoney.domains"
                :key="item.id"
                class="positionR"
              >
                <i
                  class="el-icon-remove"
                  v-if="showSubtraction"
                  @click="remoteOther(item)"
                ></i>
                <el-form-item :label="item.label">
                  <el-input v-model="item.value"></el-input>
                </el-form-item>
              </div>
            </el-form>
            <el-button
              size="mini"
              class="addOther"
              type="primary"
              icon="el-icon-plus"
              @click="addother"
              >添加</el-button
            >
          </div>
        </div>
        <div class="borderB">
          <h6>账单备注：</h6>
          <el-input type="textarea" v-model="desc" class="mb15"></el-input>
        </div>
        <span slot="footer" id="">
          <el-button type="primary">保存</el-button>
          <el-button type="primary" @click="detalisOverOrder">结算</el-button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="addOtherDialog" width="30%" :close-on-click-modal="false">
        <div>添加其他费用</div>
        <el-checkbox-group v-model="checkList">
          <el-checkbox
            v-for="item in check"
            :label="item.label"
            :key="item.id"
          ></el-checkbox>
        </el-checkbox-group>
        <div class="melf">
          <div class="melfbox">自定义费用：</div>
          <el-input v-model="otherSelf"></el-input
          ><el-button type="text" class="ml10" @click="addmelf">确定</el-button>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="melfDialog">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog
        title="订单结算"
        :visible.sync="OrderDetailsDialog"
        width="40%"
        :before-close="handleClose"
        :close-on-click-modal="false"
      >
        <div class="underline mb15">
          <h6 class="mb15">订单编号：<span class="ml20">88888888</span></h6>
          <div class="mb15">
            总计金额：<span class="ml20">88元</span
            ><i class="el-icon-arrow-down" @click="blockDetails" v-if="disb"></i
            ><i class="el-icon-arrow-up" @click="blockDetails" v-if="!disb"></i>
          </div>
          <div v-if="disb" class="ml45 mb15">
            <div>饮料：<span class="ml20">8元</span></div>
            <div>射箭:<span class="ml20">30元</span></div>
            <div>随行:<span class="ml20">50元</span></div>
          </div>
          <div class="mb15">会员抵扣：<span class="ml20">-40元</span></div>
          <div class="mb15">应结算：<span class="ml20">48元</span></div>
        </div>
        <div class="underline mb15">
          <div class="mb15">会员抵扣</div>
          <div class="vipclearing">
            <div>银卡会员</div>
            <div class="clearingBox">
              <div v-for="item in vipNow" :key="item.num">
                {{ item.title }}：{{ item.num }}
              </div>
            </div>
          </div>
        </div>

        <div class="underline mb15">
          <div class="mb15">箭票射箭</div>
          <div class="clearingBoxs mb15">
            <div>
              箭票
              <el-input-number size="mini" v-model="num4"></el-input-number>组
            </div>
            <div>
              有赞箭票
              <el-input-number size="mini" v-model="num4"></el-input-number>组
            </div>
            <div>
              纸质箭票
              <el-input-number size="mini" v-model="num4"></el-input-number>组
            </div>
          </div>
          <div style="display: flex; margin-left: 30px; margin-bottom: 10px">
            <div>
              电子卡
              <el-input-number size="mini" v-model="num4"></el-input-number>组
            </div>
            <div class="ml20">
              有赞电子卡
              <el-input-number size="mini" v-model="num4"></el-input-number>组
            </div>
          </div>

          <div class="mb15">储值射箭</div>
          <div class="clearingBoxs mb15">
            <div>
              储值射箭
              <el-input-number size="mini" v-model="num4"></el-input-number>组
            </div>
            <div>
              赠送消费
              <el-input-number size="mini" v-model="num4"></el-input-number>组
            </div>

            <div>
              饮料消费
              <el-input-number size="mini" v-model="num4"></el-input-number>组
            </div>
          </div>
          <div style="display: flex; margin-left: 30px; margin-bottom: 10px">
            <div>
              随行储值消费
              <el-input-number size="mini" v-model="num4"></el-input-number>组
            </div>
            <div class="ml20">
              随行赠送消费
              <el-input-number size="mini" v-model="num4"></el-input-number>组
            </div>
          </div>
        </div>
        <div>
          <div class="mb15">其他结算方式</div>
          <div class="disF mb15">
            <div class="tags">现金</div>
            <div class="inputbox">
              <el-input size="mini"></el-input><span>元</span>
            </div>
            <div class="tags ml20">刷卡</div>
            <div class="inputbox">
              <el-input size="mini"></el-input><span>元</span>
            </div>
          </div>
          <div class="disF mb15">
            <div class="tags">微信</div>
            <div class="inputbox">
              <el-input size="mini"></el-input><span>元</span>
            </div>
            <div class="tags ml20">团购</div>
            <div class="inputbox">
              <el-input size="mini"></el-input><span>元</span>
            </div>
          </div>
          <div class="disF mb15">
            <div class="tags">支付宝</div>
            <div class="inputbox">
              <el-input size="mini"></el-input><span>元</span>
            </div>
            <div class="tags ml20">减免</div>
            <div class="inputbox">
              <el-input size="mini"></el-input><span>元</span>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="OrderDetailsDialog = false">上一步</el-button>
          <el-button type="primary" @click="OrderDetailsDialog = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="储物寄存"
        :visible.sync="storageDialog"
        width="40%"
        :before-close="storageDialogClose"
        :close-on-click-modal="false"
      >
        <div class="positionR">
          <el-form class="width70" label-width="100px">
            <el-form-item label="会员名称：">
              <el-input v-model="orderName" class="width70"></el-input>
            </el-form-item>
            <el-form-item label="会员电话：">
              <el-input v-model="orderIphone" class="width70"></el-input>
              <el-button class="ml10" size="small" type="primary"
                >查找</el-button
              >
            </el-form-item>

            <el-form-item label="租赁期限：">
              <el-button class="ml10" size="small">1月</el-button>
              <el-button class="ml10" size="small">3月</el-button>
              <el-button class="ml10" size="small">6月</el-button>
              <el-button class="ml10" size="small">1年</el-button>
              <el-button class="ml10" size="small">2年</el-button>
            </el-form-item>
            <el-form-item label="类型：">
              <el-button class="ml10" size="small">挂钩</el-button>
              <el-button class="ml10" size="small">箱柜</el-button>
            </el-form-item>
            <el-form-item label="押金：">
              <el-input v-model="orderIphone" class="width70"></el-input>
            </el-form-item>
          </el-form>
          <div class="storagePhoto">
            <img
              src="https://www.runoob.com/wp-content/uploads/2017/01/vue.png"
              alt=""
            />
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="storageDialog = false">取 消</el-button>
          <el-button type="primary" @click="storageDialog = false"
            >创建</el-button
          >
        </span>
      </el-dialog>
      <createVipDialog v-model="cVipDialogFlag"></createVipDialog>
      <orderOverDetails v-model="cOrderDetails"></orderOverDetails>
    </div>
  </div>
</template>
<script>
import { dateNow } from "../../utils/util";
import createVipDialog from "../components/Vipdialog.vue";
import orderOverDetails from "../components/orderOverDetails.vue";
export default {
  name: "OrderManager",
  data() {
    return {
      orderTyped: "0",
      orderSelectData: [
        {
          value: "0",
          label: "全部订单",
        },
        {
          value: "1",
          label: "未结算订单",
        },
        {
          value: "2",
          label: "已结算订单",
        },
        {
          value: "3",
          label: "取消订单",
        },
      ],
      formInline: {
        orderNumer: "",
        memberIphone: "",
        creator: "",
        orderDate: "",
      },
      orderData: [
        {
          orderNumer: "123",
          member: "王小虎1",
          memberIphone: "13888888888",
          creator: "李四",
          cost: [
            {
              id: "123",
              title: "射箭",
            },
            {
              id: "456",
              title: "饮料",
            },
            {
              id: "789",
              title: "器材",
            },
          ],
          money: [
            {
              id: 1,
              title: "射箭",
              money: "100.00",
            },
            {
              id: 2,
              title: "饮料",
              money: "100.00",
            },
            {
              id: 3,
              title: "器材",
              money: "100.00",
            },
          ],
          subtotal: "1000.00",
          reality: "500.00",
          orderType: "未结算",
          orderTypenum: "1",
          remark: "备注",
        },
        {
          orderNumer: "12333333",
          member: "王小虎2",
          memberIphone: "138888888877778",
          creator: "李四",
          cost: [
            {
              id: "123",
              title: "射箭",
            },
          ],
          money: [
            {
              id: 1,
              title: "射箭",
              money: "100.00",
            },
          ],
          subtotal: "1000.00",
          reality: "500.00",
          orderType: "已结算",
          orderTypenum: "2",
          remark: "",
        },
        {
          orderNumer: "1244444333333",
          member: "王小虎3",
          memberIphone: "13888878",
          creator: "李四",
          cost: [
            {
              id: "123",
              title: "射箭",
            },
          ],
          money: [
            {
              id: 1,
              title: "射箭",
              money: "100.00",
            },
          ],
          subtotal: "1000.00",
          reality: "500.00",
          orderType: "已取消",
          orderTypenum: "3",
          remark: "",
        },
        {
          orderNumer: "124433",
          member: "王小虎4",
          memberIphone: "13888908878",
          creator: "李四",
          cost: [
            {
              id: "123",
              title: "射箭",
            },
          ],
          money: [
            {
              id: 1,
              title: "射箭",
              money: "100.00",
            },
          ],
          subtotal: "1000.00",
          reality: "500.00",
          orderType: "已结算",
          orderTypenum: "2",
          remark: "",
        },
      ],
      storageForm: {
        memberIphone: "",
        expire: "",
      },
      storageData: [
        {
          memberName: "王小虎",
          memberIphone: "11111111111",
          shop: "银泰店",
          belonger: "李四",
          checkDate: "2020-08-08",
          expireDate: "2021-08-07",
          remainingDay: "90天",
          pledge: "100",
        },
      ],
      createOrderDialog: false,
      createdate: "",
      orderName: "",
      orderIphone: "",
      createMan: "",
      openOrderDialog: false,
      archeryNum: 0,
      togetherNum: 0,
      otherMoney: {
        domains: [
          {
            id: 0,
            label: "饮料",
            value: "",
          },
        ],
      },
      upmoney: "1500",
      upafter: "黄金会员",
      storedValue: "500",
      showSubtraction: false,
      desc: "",
      cVipDialogFlag: false,
      echo: false,
      addOtherDialog: false,
      check: [
        {
          id: 1,
          label: "器材",
        },
        {
          id: 2,
          label: "寄存",
        },
        {
          id: 3,
          label: "售后",
        },
        {
          id: 4,
          label: "押金",
        },
      ],
      checkList: [],
      otherSelf: "",
      OrderDetailsDialog: false,
      vipNow: [
        {
          title: "积分",
          num: 0,
        },
        {
          title: "储值",
          num: 0,
        },
        {
          title: "赠储",
          num: 0,
        },
        {
          title: "消费积分",
          num: 0,
        },
        {
          title: "箭票",
          num: 0,
        },
        {
          title: "电子卡",
          num: 0,
        },
      ],
      disb: true,
      num4: "",
      cOrderDetails: false,
      storageDialog: false,
    };
  },
  components: {
    createVipDialog,
    orderOverDetails,
  },
  methods: {
    orderType() {
      console.log(this.orderTyped);
    },
    tableRowClassName({ row }) {
      if (row.orderTypenum == "2") {
        return "success-row";
      } else if (row.orderTypenum == "1") {
        return "warning-row";
      } else if (row.orderTypenum == "3") {
        return "cancel-row";
      }
    },
    //创建订单、
    createOrder() {
      this.createOrderDialog = true;
      this.createdate = dateNow();
    },
    //订单详情、
    openOrderDetail() {
      this.cOrderDetails = true;
    },
    // 添加其他
    addother() {
      this.showSubtraction = true;
      this.addOtherDialog = true;
    },
    // 删除其他
    remoteOther(item) {
      var index = this.otherMoney.domains.indexOf(item);
      if (index !== -1) {
        this.otherMoney.domains.splice(index, 1);
      }
    },
    // 打开新建会员弹窗
    creatVip() {
      this.cVipDialogFlag = true;
      this.echo = true;
    },
    // 添加自定义费用
    addmelf() {
      if (this.otherSelf) {
        this.check.push({
          id: this.check.length + 1,
          label: this.otherSelf,
        }),
          (this.otherSelf = "");
      }
    },
    // 关闭自定义添加弹窗
    melfDialog() {
      this.addOtherDialog = false;
      console.log(this.checkList);
      var arr = [];
      this.check.map((item) => {
        this.checkList.map((itm) => {
          if (item.label == itm) {
            arr.push({
              id: item.id,
              label: item.label,
              value: "",
            });
          }
        });
      });
      this.otherMoney.domains = this.otherMoney.domains.concat(arr);
    },
    // 订单结算
    overOrder() {
      this.openOrderDialog = true;
      this.createdate = dateNow();
    },
    // 订单详情结算
    detalisOverOrder() {
      this.OrderDetailsDialog = true;
    },
    blockDetails() {
      this.disb = !this.disb;
    },
    createStorage() {
      this.storageDialog = true;
    },
    storageDialogClose() {
      this.storageDialog = false;
    },
  },
};
</script>

<style scoped>
.fz16 {
  font-size: 16px;
}
.colorBlue {
  color: #409eff;
}
.colorRed {
  color: red;
}
.underline {
  border-bottom: 1px solid #ccc;
}
.mb15 {
  margin-bottom: 15px;
}
.ml20 {
  margin-left: 20px;
}
.ml10 {
  margin-left: 10px;
}
.ml45 {
  margin-left: 45px;
}
.positionR {
  position: relative;
}
.disF {
  display: flex;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.width70 {
  width: 70%;
}
.orderMain {
  padding: 30px;
}
.orderTotle {
  font-size: 18px;
  font-weight: 700;
}
.btnClass {
  margin-right: 20px;
  margin-bottom: 10px;
}
.flexTitle {
  font-size: 16px;
  padding: 0 0 20px 18px;
  display: flex;
  justify-content: space-between;
}
.width70 .el-input {
  width: 70%;
}
.borderB {
  padding-left: 18px;
  border-bottom: 1px solid #ccc;
}
.oederManPhoto {
  position: absolute;
  width: 140px;
  height: 140px;
  top: 30px;
  right: 30px;
}
.oederManPhoto img {
  width: 100%;
  height: 100%;
}
.right {
  width: 140px;
  height: 140px;
}
.right img {
  width: 100%;
  height: 100%;
}
.addOther {
  position: absolute;
  top: 40px;
  right: 10px;
}
.el-icon-remove {
  color: red;
  position: absolute;
  top: 33%;
  left: 8%;
}
.melf {
  display: flex;
  margin-top: 20px;
}
.melf .melfbox {
  margin-top: 10px;
}
.melf .el-input {
  width: 70%;
}
.vipclearing {
  margin-left: 30px;
  display: flex;
  margin-bottom: 15px;
}
.clearingBox {
  display: flex;
  flex-wrap: wrap;
  margin-left: 50px;
}
.clearingBox > div {
  width: 30%;
}
.clearingBoxs {
  display: flex;
  flex-wrap: wrap;
  margin-left: 30px;
}
.clearingBoxs > div {
  width: 30%;
  margin-left: 10px;
}
.tags {
  width: 15%;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.inputbox {
  width: 30%;
  margin-left: 10px;
}

.inputbox .el-input {
  width: 90%;
  margin-left: 5px;
}
.storagePhoto {
  position: absolute;
  width: 100px;
  height: 100px;
  top: 0;
  right: 50px;
}
.storagePhoto img {
  width: 100%;
  height: 100%;
}
</style>
